module.exports = __webpack_public_path__ + "img/image 1.a84f8567.png";